<app-action-bar [items]="actionBar"></app-action-bar>
<app-content-header [title]="title" [breadcrumb]="breadcrumb"></app-content-header>
<app-filter (search)="search()" (clearFilter)="clearFilter()">
    <div class="row">
        <div class="col-4">
            <app-control label="Docking Date" [(ngModel)]="filter.date" type="datetime" [time]="false" [required]="true"></app-control>
        </div>
        <div class="col-4">
            <app-control label="Ferry Name" [(ngModel)]="filter.ferryId" type="codelist"
                codelist="ApprovedVessel"></app-control>
        </div>
        <div class="col-4">
            <app-control label="Berth" [(ngModel)]="filter.berthId" type="codelist"
                codelist="Berth"></app-control>
        </div>
    </div>
    <div class="row">
        <div class="col-4">
            <app-control label="Arrival Agency" [(ngModel)]="filter.arrivalAgencyId" type="codelist"
                codelist="Organization"></app-control>
        </div>
        <div class="col-4">
            <app-control label="Departure Agency" [(ngModel)]="filter.departureAgencyId" type="codelist"
            codelist="Organization"></app-control>
        </div>
    </div>
</app-filter>
<div class="card card-border-top mt-3 mb-5">
    <div class="card-body">
        <app-grid [data]="gridData" [sortable]="true" (pageChange)="search()">
            <kendo-grid-column field="ferryName" title="{{'Ferry Name' | translate}}">
            </kendo-grid-column>
            <kendo-grid-column field="positionName" title="{{'Position' | translate}}">
            </kendo-grid-column>
            <kendo-grid-column [title]="'Docking Date' | translate" field="ata">
                <ng-template kendoGridCellTemplate let-item>
                    <span>{{item.ata | date}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [title]="'Departure Date' | translate" field="atd">
                <ng-template kendoGridCellTemplate let-item>
                    <span>{{item.atd | date}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="berthNames" title="{{'Berth' | translate}}">
            </kendo-grid-column>
            <kendo-grid-column field="daysInPort" title="{{'Days In Port' | translate}}" decimals="2">
            </kendo-grid-column>
            <kendo-grid-column field="arrivalAgentName" title="{{'Arrival Agency' | translate}}">
            </kendo-grid-column>
            <kendo-grid-column field="departureAgentName" title="{{'Departure Agency' | translate}}">
            </kendo-grid-column>
            <kendo-grid-column field="generalRemarks" title="{{'Remark' | translate}}">
            </kendo-grid-column>
        </app-grid>
    </div>
</div>
